(function () {
    'use strict';

    angular
        .module('elogbooks.admin.job-requisites')
        .controller('JobRequisitesServiceProvidersEditController', JobRequisitesServiceProvidersEditController);

    JobRequisitesServiceProvidersEditController.$inject = ['$stateParams', '$state', '$q', 'messenger', 'apiClient', 'lodash', 'jobRequisiteResponse'];

    function JobRequisitesServiceProvidersEditController ($stateParams, $state, $q, messenger, apiClient, lodash, jobRequisiteResponse) {
        var vm = this;
        vm.jobRequisite = jobRequisiteResponse;
        vm.multiSelect = {
            link: '/serviceproviders',
            selectedLink: vm.jobRequisite.getLink('serviceproviders'),
            selectedSearchKey: 'name',
            selectedSearchParams: { limit: 100 },
            selectedItems: [],
            pendingAdditions: [],
            pendingRemovals: [],
            responseKeyPath: 'serviceproviders',
            searchKey: 'name',
            allTitle: 'ALL_SERVICE_PROVIDERS',
            selectedTitle: 'SELECTED_SERVICE_PROVIDERS',
            searchParams: { status: 'active', limit: 100, notAttachedToJobRequisiteId: jobRequisiteResponse.id },
            loading: true,
            selectedLoading: true
        };

        $q.all([
            apiClient.get(vm.jobRequisite.getLink('serviceproviders'), { limit: 100, order: 'name' }),
            apiClient.get(vm.multiSelect.link, vm.multiSelect.searchParams)
        ]).then(function (results) {
            var selectedResponse = results[0];
            var response = results[1];

            if (!selectedResponse || !response) {
                return $q.reject();
            }

            vm.multiSelect.initialSelectedResponse = selectedResponse;
            vm.selectedServiceProviders = selectedResponse.serviceproviders;

            if (vm.selectedServiceProviders) {
                angular.forEach(vm.selectedServiceProviders, function (serviceProvider) {
                    vm.multiSelect.selectedItems.push({href: serviceProvider.getLink('self'), value: serviceProvider.name});
                });
            }

            vm.multiSelect.selectedLoading = false;

            vm.multiSelect.initialResponse = response;
            vm.multiSelect.items = lodash.differenceBy(
                lodash.map(response.serviceproviders, function (serviceProvider) {
                    return {href: serviceProvider.getLink('self'), value: serviceProvider.name};
                }),
                vm.multiSelect.selectedItems,
                'href'
            );
            vm.multiSelect.loading = false;
        }).catch(function () {
            vm.multiSelect.selectedLoading = false;
            vm.multiSelect.loading = false;
            vm.multiSelect.loadError = true;
            messenger.error('REQUEST_ERROR');
        });

        vm.pageTitle = 'JOB_REQUISITE_SERVICEPROVIDER_EDIT';
        vm.update = updateAction;

        function updateAction() {
            if (vm.updating || vm.multiSelect.loading || vm.multiSelect.selectedLoading || vm.multiSelect.loadError) {
                return;
            }

            var additions = vm.multiSelect.pendingAdditions || [];
            var removals = vm.multiSelect.pendingRemovals || [];

            if (!additions.length && !removals.length) {
                return $state.go('^', $stateParams, { reload: true }).then(function () {
                    messenger.success('JOB_REQUISITE_SERVICEPROVIDER_UPDATED');
                });
            }

            var modifyServiceProvidersLink = vm.jobRequisite.getLink('modify-serviceproviders');

            if (!modifyServiceProvidersLink) {
                messenger.error('REQUEST_ERROR');
                return;
            }

            vm.updating = true;

            var data = {
                _links: {
                    'added-serviceprovider': additions,
                    'removed-serviceprovider': removals
                }
            };

            apiClient.update(modifyServiceProvidersLink, data).then(function (response) {
                if (response) {
                    return $state.go('^', $stateParams, { reload: true }).then(function () {
                        messenger.success('JOB_REQUISITE_SERVICEPROVIDER_UPDATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                    vm.updating = false;
                }
            }).catch(function () {
                messenger.error('REQUEST_ERROR');
                vm.updating = false;
            });
        }
    }

})();
